import axios from "axios";

export function fetchShopsByPage(params) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/query`,
    params: params
  };
  return axios(config);
}

export function fetchShops() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/bulk`
  };
  return axios(config);
}

export function fetchShopInfo(id) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${id}`
  };
  return axios(config);
}
export function fetchShopInfoByAccountId(id) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${id}/info`
  };
  return axios(config);
}

export function fetchShopEdit(id) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${id}`
  };
  return axios(config);
}

export function fetchSiAccounts() {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/si-accounts`
  };
  return axios(config);
}

export function fetchQrcode(id) {
  var config = {
    method: "get",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${id}/qrcode`
  };
  return axios(config);
}

export function fetchRichmenus() {
  let configBusiness = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/richmenus`
  };
  return axios(configBusiness);
}

export function fetchContract(data) {
  let accountId = data.accountId;
  let businessId = data.businessId;
  let configBusiness = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${accountId}/contract?businessId=${businessId}`
  };
  return axios(configBusiness);
}

export function fetchPlans() {
  let config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/contract/plans`
  };
  return axios(config);
}

export function fetchPromotions(data) {
  let businessId = data.businessId;
  let config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${businessId}/promotions`
  };
  return axios(config);
}

export function fetchSuggestTags(params) {
  let config = {
    method: "GET",
    url: `${process.env.VUE_APP_APIHOST}/gaa/tags/account-tags`,
    params
  }
  return axios(config);
}

export function fetchPrintersUnderShop(accountId, shop) {
  let config = {
      method: 'GET',
      url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/printers`,
      params: shop
  }
  return axios(config);
}

export function getInvoiceSetting(accountId) {
  let config = {
      method: 'GET',
      url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/invoice`
  }
  return axios(config);
}

export function fetchMWSetting(accountId) {
  let config = {
    method: 'GET',
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${accountId}/mw-settings`,
  }
  return axios(config);
}

export function fetchMWActive(accountId) {
  let config = {
    method: 'GET',
    url: `${process.env.VUE_APP_APIHOST}/gaa/console/${accountId}/mw-settings-active`
  }
  return axios(config);
}

export function fetchServices(accountId) {
  let config = {
    method: 'GET',
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${accountId}/services`
  }
  return axios(config);
}

export function fetchServiceUrls(accountId) {
  let config = {
    method: 'GET',
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${accountId}/service-urls`
  }
  return axios(config);
}

export function fetchPosDvrSetting(accountId) {
  let config = {
    method: 'GET',
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${accountId}/dvr-settings`
  }
  return axios(config);
}

// QC-3316: 列該店接單機(iDOO/counter)使用者帳號,供「管理員帳號」下拉。僅回 id/username。
export function fetchCounterUsers(accountId) {
  let config = {
    method: 'GET',
    url: `${process.env.VUE_APP_APIHOST}/gaa/shops/${accountId}/counter-users`
  }
  return axios(config);
}